/**
 * FilePowerpointIcon — auto-generated by scripts/generate-icons.ts.
 * Do NOT edit manually — re-run `yarn codegen:icons` to regenerate.
 */

// SVGProps is used by the SVGR-generated component below.
import type { SVGProps } from 'react'
import { makeIcon } from '../make-icon'

interface SVGRProps {
  title?: string
  titleId?: string
}
const FilePowerpointIconSvg = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fillRule="evenodd"
      d="M5 3h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2m4.945 8.942h1.675a2.17 2.17 0 0 0 1.481-.442 1.64 1.64 0 0 0 .5-1.293q0-1.65-1.919-1.651H9.945zm2.023-4.933a4.13 4.13 0 0 1 2.735.802 2.87 2.87 0 0 1 .953 2.322 3.23 3.23 0 0 1-.47 1.735 3.14 3.14 0 0 1-1.333 1.178 4.5 4.5 0 0 1-2.006.422h-1.9V17H8V7.01z"
      clipRule="evenodd"
    />
  </svg>
)

/** @see {@link https://design.reapit.com.au} Reapit DS icon */
export const FilePowerpointIcon = makeIcon('FilePowerpointIcon', FilePowerpointIconSvg)
